module.exports = __webpack_public_path__ + "static/media/McMaster.cff6447e.svg";